import React from "react";
import { Box, Typography, Button, Stack, Grid } from "@mui/material";

import { isNative } from "../../utils/platform.utils";
import { openInAppBrowser } from "../../utils/browser.utils";

import { getFinFactorStaticUI } from "../../store/parsers/finfactor.parser";

import ShieldSVG from "../../assets/FinFactor/Shield.svg";
import SecuritySVG from "../../assets/FinFactor/Security.svg";
import EncryptedSVG from "../../assets/FinFactor/Encrypted.svg";
import CredenailsSVG from "../../assets/FinFactor/Credenails.svg";

import CommonFeatureCard from "../../components/FinFactorInvestment/CommonFeatureCard";
const FinConsentContainer = ({ onConsent }) => {

    const { myInvestments, securitySection } = getFinFactorStaticUI();

    const iconMap = {
        Encrypted: EncryptedSVG,
        Security: SecuritySVG,
        Credenails: CredenailsSVG,
    };

    return (

        <Box
            sx={{
                backgroundColor: "#13172a",
                borderRadius: "12px",
                color: "white",
                p: { xs: 2.5, md: 4 }
            }}
        >

            {/* Header */}

            <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", md: "center" }}
                spacing={2}
            >

                <Box>

                    <Typography variant="h5" fontWeight="semibold">
                        {myInvestments.title}
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.7)",
                            mt: 0.5
                        }}
                    >
                        {myInvestments.subtitle}
                    </Typography>

                </Box>


                <Stack direction="row" spacing={2} sx={{ width: { xs: "100%", md: "auto" } }}>

                    <Button
                        variant="contained"
                        onClick={onConsent}
                        sx={{
                            backgroundColor: "#0c335d",
                            textTransform: "none",
                            borderRadius: "8px",
                            width: { xs: "100%", md: "auto" },
                            '&:hover': {
                                backgroundColor: "#0c335d",
                            }
                        }}
                    >
                        {myInvestments.buttonText}
                    </Button>
                </Stack>

            </Stack>



            {/* Feature Section */}

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    py: 3,
                }}
            >

                <Box
                    component="svg"
                    sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        top: 0,
                        left: 0,
                        zIndex: 0,
                        display: { xs: "none", md: "block" }
                    }}
                    viewBox="0 0 1000 400"
                >
                    <line x1="150" y1="90" x2="820" y2="90" stroke="#616060" />
                    <line x1="150" y1="200" x2="820" y2="200" stroke="#616060" />
                    <line x1="150" y1="320" x2="820" y2="310" stroke="#616060" />
                    <line x1="500" y1="90" x2="500" y2="315" stroke="#616060"></line>                </Box>


                <Stack spacing={4} sx={{ zIndex: 1, width: "100%" }}>

                    <Stack
                        direction={{ xs: "column", md: "row" }}
                        spacing={{ xs: 4, md: 22 }}
                        alignItems="center"
                        justifyContent="center"
                    >

                        {/* Left */}

                        <Stack spacing={2} sx={{ width: { xs: "100%", md: "auto" } }}>
                            {myInvestments.features.left.map((f) => (
                                <CommonFeatureCard
                                    key={f.id}
                                    label={f.label}
                                    border="none"
                                />
                            ))}
                        </Stack>



                        {/* Shield */}

                        <Box
                            sx={{
                                width: 130, // Increased to provide better spacing
                                height: 80,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",

                            }}
                        >
                            <Box
                                component="img"
                                src={ShieldSVG}
                                sx={{
                                    width: 100,
                                    height: 100
                                }}
                            />
                        </Box>



                        {/* Right */}

                        <Stack spacing={2} sx={{ width: { xs: "100%", md: "auto" } }}>
                            {myInvestments.features.right.map((f) => (
                                <CommonFeatureCard
                                    key={f.id}
                                    label={f.label}
                                    border="none"
                                />
                            ))}
                        </Stack>

                    </Stack>

                </Stack>

            </Box>



            {/* Security Section */}

            <Box sx={{ mt: 4, mb: 1 }}>

                <Typography variant="h5" fontWeight="semibold" mb={1}>
                    {securitySection.title}
                </Typography>

                <Typography
                    sx={{
                        color: "rgba(255,255,255,0.7)",
                        mb: 2
                    }}
                >
                    {securitySection.subtitle}
                </Typography>

            </Box>


            <Grid container spacing={2}>

                {securitySection.cards.map((card) => (

                    <Grid item xs={12} md={4} key={card.id}>
                        <CommonFeatureCard
                            label={card.title}
                            icon={iconMap[card.icon]}
                            backgroundColor="#25293b"
                            border="none"
                            card
                            iconSize="44px"
                        />
                    </Grid>

                ))}

            </Grid>



        </Box>

    );
};

export default FinConsentContainer;